import { useFeatureFlagContext } from '../providers/FeatureFlagProvider';
import { isFeatureFlagAdminVisible } from '../state/adminUIVisibility';

export const useFeatureFlag = (flagKey: string): boolean => {
  const { isEnabled } = useFeatureFlagContext();
  return isEnabled(flagKey);
};

export { isFeatureFlagAdminVisible };
